import React, { useState, useEffect } from 'react';
import EncaissementListTable from '../encaissement_list/EncaissementListTable';
import EncaissementListCard from '../encaissement_list/EncaissementListCard';
import { getEncaissementsByUser, clearEncaissements } from '../../flux/actions/encaissementActions';
import { getSocietes, clearSocietes } from '../../flux/actions/societeActions';
import { getUsers } from '../../flux/actions/userActions';
import { Container, Row, Col, Label, CustomInput } from 'reactstrap';

import { connect } from 'react-redux';
import { IUserEncaissementsListContainer, IUserEncaissementListReduxProps } from '../../types/interfaces';
import Select from 'react-select';
import { useBeforeunload } from 'react-beforeunload';
import Durations from '../Durations';
import Loading from '../Loading';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle, faQuestionCircle, faWallet } from '@fortawesome/free-solid-svg-icons'
import { PRIVILEGE } from '../../types/privileges';
import ReactTooltip from 'react-tooltip';
import { constants } from '../../types/constants';

const UserEncaissementsListContainerComponent = ({ 
  getEncaissementsByUser,
  clearEncaissements,
  encaissement,
  getSocietes,
  clearSocietes,
  getUsers,
  societe,
  user,
  auth
 }: IUserEncaissementsListContainer) => {

  const { encaissements, loading } = encaissement;
  const { users, loading: loadingU } = user;
  const { societes, loading: loadingS } = societe;
  const [tableData, setTableData] = useState(encaissements);
  const [filteredRows, setFilteredRows] = useState(encaissements);
  const selectOptions = [{value: {id: "ALL", LIBELE: "Tous les projets"}, label: "Tous les projets"}, ...societes.map(e => ({value: e, label: e.LIBELE}))];
  const [societeValue, setSocieteValue] = useState<any>('');
  const userOptions = (auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? [{id: "ALL", LOGIN: "Tout"}, ...users.map(e => ({id: e.id, LOGIN: e.username}))] : [{id: auth?.user?.id, LOGIN: auth?.user?.username}]).map(e => ({value: e.id, label: e["LOGIN"] || e["username"], user: e}));
  const [selectedUser, setSelectedUser] = useState<any>('');
  const titledOptions = [{value: "ALL", label: "Tout"}, {value: "TITLED", label: "Titrés"}, {value: "UNTITLED", label: "Non titrés"}];
  const [titledValue, setTitledValue] = useState<any>(titledOptions.find(e => e.value === "ALL"));
  const sNotaireOptions = [{value: "NOT YET", label: "Pas encore signé"}, {value: "CHEZ", label: "Signé client"}, {value: "EN COURS", label: "Signature en cours"}, {value: "SIGNE", label: "Signé notaire"}];
  const [sNotaireValues, setSNotaireValues] = useState<any[]>(sNotaireOptions);
  const [byCharge, setByCharge] = useState(true);
  // const [includeSigneNotaire, setIncludeSigneNotaire] = useState(true);
  const [selectedDuration, setSelectedDuration] = useState('');
  const [selectedRows, setSelectedRows] = useState(Array());
  const [clearFilters, setClearFilters] = useState(false);
  const [showAllValue, setShowAllValue] = useState(true);
  
  const changeShowAllHandle = (e) => {
    setShowAllValue(e.target.checked);
  };

  useBeforeunload((e) => {
    if(selectedRows.length)
      e.preventDefault();
  });

  useEffect(() => {
    refresh();
  }, [getEncaissementsByUser, byCharge, selectedDuration, selectedUser, societeValue, titledValue/*, includeSigneNotaire*/, showAllValue, users, auth]);

  const refresh = () => {
    if(societeValue && auth?.user)
      getEncaissementsByUser(byCharge ? 1 : 0, selectedDuration, selectedUser.id === "ALL" ? ((auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? users : auth.user.underlings)?.map(e => e.id) || []) : [selectedUser.id], selectedUser.id === "ALL" && !!auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? 1 : 0, societeValue["id"], societeValue["LIBELE"], auth.user.societes || [], (titledValue || titledOptions[1]).value, /*includeSigneNotaire ? 1 : 0*/1, showAllValue ? 1 : 0);
    else
      clearEncaissements();
  }

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  useEffect(() => {
    auth && auth.user && getSocietes(auth?.user.societes?.map(e => e.id) || []);
  }, [getSocietes, auth]);

  // useEffect(() => {
  //   if(auth?.user?.id !== undefined && selectedUser === '')
  //     setSelectedUser(userOptions.find(e => e.value === (auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? "ALL" : auth.user.id))?.user || '')
  // }, [auth?.user?.id, auth?.user?.underlings]);

  useEffect(() => {
    if(auth?.user?.id !== undefined && selectedUser === '')
      setSelectedUser(userOptions.find(e => e.user.id === auth.user.id)?.user || '')
  }, [auth?.user?.id, auth?.user?.underlings]);

  useEffect(() => {
    if(!societeValue && societes && societes.length){
      if(auth && auth.user){
        for(let so of societes)
          if(so.id == auth.user.last_societe){
            setSocieteValue(so);
            break
          }
      }
    }
  }, [societes]);

  const handleSocieteChange = data => {
    setSocieteValue(data ? data.value : '');
  }
  const handleUserChange = data => {
    setSelectedUser(data ? data.user : '');
  }
  const handleTitledChange = data => {
    setTitledValue(data || '');
  }
  const handleSNotaireChange = data => {
    setSNotaireValues(data?.length ? data : []);
  }

  // const changeIncludeSigneNotaireHandle = (e) => {
  //   setIncludeSigneNotaire(e.target.checked);
  // };

  const filterOptions = (e, input) => {
    if(!e.value)
      return false;
    const filterWords = input.trim().split(' ');
    
    if(filterWords.length){
      let allWordsMatch = true;
      for(let word of filterWords){
        word = word.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        if(!e.value.LIBELE || !e.value.LIBELE.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(word))
          allWordsMatch = false
      }
      return allWordsMatch
    }
    
    return true;
  }

  useEffect(() => {
    return () => {
      clearEncaissements();
      clearSocietes();
    }
  }, []);

  useEffect(() => {
    setTableData(encaissements
      .filter(e => sNotaireValues.some(e => e.value === "NOT YET") || (e["contrat_encaissements"] || []).some(e => e.contrat?.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE) || (e["contrat_encaissements"] || []).some(e => !!e["en_cours_signature"]) || (e["contrat_encaissements"] || []).some(e => !!e["chez_notaire"]))
      .filter(e => sNotaireValues.some(e => e.value === "CHEZ") || (e["contrat_encaissements"] || []).some(e => e.contrat?.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE) || (e["contrat_encaissements"] || []).some(e => !e["en_cours_signature"]) || (e["contrat_encaissements"] || []).some(e => !e["chez_notaire"]))
      .filter(e => sNotaireValues.some(e => e.value === "EN COURS") || (e["contrat_encaissements"] || []).some(e => e.contrat?.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE) || (e["contrat_encaissements"] || []).some(e => !e["en_cours_signature"]))
      .filter(e => sNotaireValues.some(e => e.value === "SIGNE") || (e["contrat_encaissements"] || []).some(e => e.contrat?.bien?.STATUT !== constants.STATUT_SIGNE_NOTAIRE)));
  }, [encaissements, sNotaireValues]);

  return (
    <>
      {false && <Container>
        <Row className="justify-content-between">
          <Col sm="12" md="6"><h2 className="title">Encaissements</h2></Col>
          <Col sm="12" md="2" className="listPageFilterTitle">
            <Label for="societes">Projet : </Label>
          </Col>
          <Col sm="12" md="4" className="listPageFilterSelect">
              <Select
                id="societes"
                className="reactselect"
                classNamePrefix="react-select"
                value={societeValue ? {label: societeValue["LIBELE"], value: societeValue} : null}
                onChange={handleSocieteChange}
                placeholder={'Chercher par nom...'}
                isClearable={false}
                // isLoading={loadingS}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={true}
                labelKey='LIBELE'
                options={selectOptions}
                menuContainerStyle={{ zIndex: 9999999 }}
              />
          </Col>
        </Row>
      </Container>}
      <Container>
        <Row style={{marginBottom: "5px"}}>
          <Col xs="12" lg="8"><h3 className="title"><FontAwesomeIcon icon={faWallet} />&nbsp;&nbsp;Mes Encaissements</h3></Col>
          <Col sm="12" lg="4" className="listPageFilterSelect">
            <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
              <Label for="societe">Projet : </Label>
            </div>
            <Select
              name="reactselect"
              className="reactselect"
              classNamePrefix="react-select"
              id="societe"
              value={societeValue ? {label: societeValue["LIBELE"], value: societeValue} : null}
              onChange={handleSocieteChange}
              placeholder={'Chercher par projet...'}
              isClearable={true}
              isLoading={loadingS}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              labelKey='LIBELE'
              // valueKey='code'
              options={selectOptions}
              filterOption={filterOptions}
            />
          </Col>
        </Row>
        <Row className="justify-content-between">
          <Col sm="12" lg="4" className="listPageFilterSelect">
            <div className="listPageFilterTitleWithChoices" style={{padding: "0 8px"}}>
              <div className={`listPageFilterTitleChoice${byCharge ? " listPageFilterTitleChosen" : ""}`} onClick={() => setByCharge(true)} style={{marginBottom: "2px"}} title="Filter par chargé du bien">Chargé du bien : </div>
              <div className={`listPageFilterTitleChoice${!byCharge ? " listPageFilterTitleChosen" : ""}`} onClick={() => setByCharge(false)} title="Filter par vendeur">Commercial : </div>
            </div>
            <Select
              name="user"
              className="reactselect"
              classNamePrefix="react-select"
              value={selectedUser ? {label: selectedUser["LOGIN"] || selectedUser["username"], value: selectedUser.id, user: selectedUser} : null}
              onChange={handleUserChange}
              placeholder={'Chercher par nom...'}
              isClearable={true}
              isLoading={loadingU}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              // labelKey='LOGIN'
              // valueKey='countryCode'
              options={userOptions}
            />
          </Col>
          <Col sm="12" lg="5" className="listPageFilterSelect">
            <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
              <Label for="snotaire">Statut notaire : </Label>
            </div>
            <Select
              id="snotaire"
              className="reactselect"
              classNamePrefix="react-select"
              isMulti
              value={sNotaireValues?.map(e => ({label: e.label, value: e.value})) || []}
              // value={{value: societeValue.value, label: societeValue.label}}
              onChange={handleSNotaireChange}
              placeholder={'Chercher...'}
              isClearable={false}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              options={sNotaireOptions}
              menuContainerStyle={{ zIndex: 9999999 }}
            />
          </Col>
          <Col sm="12" lg="3" className="listPageFilterSelect">
            <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
              <Label for="titled">Titrés : </Label>
            </div>
            <Select
              id="titled"
              className="reactselect"
              classNamePrefix="react-select"
              defaultValue={titledOptions[1]}
              value={titledValue}
              // value={{value: societeValue.value, label: societeValue.label}}
              onChange={handleTitledChange}
              isClearable={false}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={false}
              options={titledOptions}
            />
          </Col>
          {/* <Col xs="12" lg="3" className="fullFlexCenter justify-content-center justify-content-lg-end">
            <CustomInput type="switch" id="includeSigneNotaire" name="includeSigneNotaireSwitch" label="Signés notaire inclus" checked={includeSigneNotaire} onChange={changeIncludeSigneNotaireHandle} />
          </Col> */}
        </Row>
      </Container>
      {/* <Container><h2 className="title"><FontAwesomeIcon icon={faExclamationCircle} />&nbsp;&nbsp;Portefeuille Bureau de vente</h2></Container> */}
      <Container>
        <Row className="justify-content-center justify-content-md-end" style={{alignItems: "center"}}>
          <CustomInput type="switch" id="showAll" name="showAllSwitch" label="Inclure les anciens encaissements" checked={showAllValue} onChange={changeShowAllHandle} />
          &nbsp;<FontAwesomeIcon icon={faQuestionCircle} style={{cursor: "pointer"}} data-tip data-for="showAll_tooltip" />
          <ReactTooltip effect="solid" id="showAll_tooltip" type={"dark"}>
            Cochez pour inclure les encaissements saisis avant le 01/07/2021
          </ReactTooltip>
        </Row>
      </Container>
      <Durations selectedDuration={selectedDuration} setSelectedDuration={setSelectedDuration} style={{marginTop: "6px"}} />
      {loading ? <Loading topSpace /> : <EncaissementListTable encaissementsData={tableData} setTableData={setTableData} setFilteredRows={setFilteredRows} showProjectColumn={societeValue?.id === "ALL"} showStatutColumn={true} />}
      <EncaissementListCard allRows={encaissements} filteredRows={filteredRows} selectedProjet={societeValue} />
    </>
  );
};

const mapStateToProps = (state: IUserEncaissementListReduxProps) => ({
  encaissement: state.encaissement,
  societe: state.societe,
  user: state.user,
  auth: state.auth
});

export default connect(mapStateToProps, { getEncaissementsByUser, clearEncaissements, getSocietes, clearSocietes, getUsers })(UserEncaissementsListContainerComponent);
